import { useEffect, useState } from "react";

import TestInfoClasses from '../components/Tests/TestInfo.module.css';
import { getLabConfig } from '../utils/api';

const BackendTest = (props) => {

	const [ccProvider, setCcProvider] = useState([]);
    useEffect(() => {
        async function fetchCCProvider() {
        	const ccProvider = await getLabConfig('DTCCCPROVIDER');
            setCcProvider(ccProvider);            
        }
        fetchCCProvider();
	},[])

    return (
			<div className={TestInfoClasses.testInfo}>
				<div className={TestInfoClasses.testInfoContent}>
			    		<span>&nbsp;</span>
			    		<span>Testing the backend server<br/>
						{ccProvider}
						</span>
			    		<span>&nbsp;</span>
		    	</div>
            </div>
        
    );
}

export default BackendTest;


